import { Utils } from "@/plugins/utils";
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVd1: [],
		loading: false,
		itemsPerPage: 100000,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD"),
		until: moment().format("YYYY-MM-DD"),
	},
	getters: {
	
	},
	mutations: {
		initForm(state){
			state.lstVd1 = []
			state.itemsPerPage = 20
			state.hasNext = false
		},
		setParamsDataTable(state, payload){
			state.lstVd1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async search(store, { limit = 20, page = 1 }){
			store.state.loading = true
			store.commit("initForm")
			let url = `/Consignment/Order/Search?search=${store.state.search}&limit=${limit}&page=${page}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}
			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVd1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printReportOpenConsignments(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Consignment/Order/PrintReportOpenConsignments", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async findOpenConsignment(store, cf1cliente){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados de consignado...", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get( `/Consignment/Order/FindOpenConsignment/${cf1cliente}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async findMaxReturnConsignmentAmount(store, {customer, forInvoice = false }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados de consignado...", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get( `/Consignment/Order/FindMaxReturnConsignmentAmount/${customer}?forInvoice=${forInvoice}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return 0
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		}
	}
}